import { create } from 'zustand';

function buildAllowPerfis(perfisSelecionados = []) {
  return new Set(
    perfisSelecionados.map(Number)
  );
}

export const useAuthStore = create((set) => ({
  
  user: undefined,

  perfisDisponiveis: [],
  perfisSelecionados: [],

  allowPerfis: new Set(),

  setUser: (user) =>
    set({ user }),

  setPerfisDisponiveis: (perfisDisponiveis) =>
    set({ perfisDisponiveis }),

  setPerfisSelecionados: (perfisSelecionados) =>
      set({
        perfisSelecionados,
        allowPerfis: buildAllowPerfis(perfisSelecionados)
      }),

  reset: () =>
    set({
      user: null,
      perfisDisponiveis: [],
      perfisSelecionados: [],
      allowPerfis: new Set()
    })

}));